import * as Yup from 'yup';
import { date } from 'yup';
import { isDate, parse, sub } from 'date-fns';

const minYear = sub(new Date(), {
  years: 99,
});

const maxYear = sub(new Date(), {
  years: 16,
});

const parseDateString = (value: any, originalValue: any) => {
  return isDate(originalValue)
    ? originalValue
    : parse(originalValue, 'yyyy-MM-dd', new Date());
};

export const EditProfileFormValidation = Yup.object().shape({
  firstname: Yup.string().required('Please enter your first name'),
  lastname: Yup.string().required('Please enter your last name'),
  birthday: date()
    .transform(parseDateString)
    .min(minYear, 'Invalid year')
    .max(maxYear, 'Must be older than 16 years'),
  gender: Yup.string().nullable(true),
  phoneNumber: Yup.string().required(
    'Please enter your phone number - so we can contact you! ',
  ),
  email: Yup.string()
    .email('Please enter a valid email address')
    .required('An email address is required'),
  address: Yup.object().shape({
    zipCode: Yup.string()
      .test('zipcode-check', 'Zip Code is invalid', (value, context) => {
        if (value === undefined) return true;
        if (!/[0-9]+/.test(value)) return false;
        if (value.length !== 5) return false;
        return !!context.parent.state;
      })
      .required('Please enter a Zip Code'),
  }),
  hobbies: Yup.object().test(
    'object-check',
    'One value is required',
    (value) => {
      const check = Object.keys(value).every((hobby) => !value[hobby]);
      return !check;
    },
  ),
  hasCar: Yup.bool(),
  commuteTime: Yup.number().nullable(true).required('A value is required'),
  legal: Yup.object().shape({
    allowedToWork: Yup.bool(),
    chargesOrWarrant: Yup.bool(),
  }),
  hasPaidExperience: Yup.bool(),
  certifications: Yup.object().shape({
    hha: Yup.bool(),
    cna: Yup.bool(),
    cprAndFirstAid: Yup.bool(),
    qmap: Yup.bool(),
    none: Yup.bool(),
  }),
  schedule: Yup.object().shape(
    {
      Mon: Yup.bool(),
      Tue: Yup.bool(),
      Wed: Yup.bool(),
      Thu: Yup.bool(),
      Fri: Yup.bool(),
      Sat: Yup.bool(),
      Sun: Yup.bool(),
      hourly: Yup.bool(),
      liveIn: Yup.bool(),
      hours: Yup.number(),
    },
    [['hourly', 'liveIn']],
  ),
});

export const EditAgencyFormValidation = Yup.object().shape({
  name: Yup.string().required('Please enter agency name'),
  email: Yup.string()
    .email('Please enter a valid email address')
    .required('An email address is required'),
  requirements: Yup.object().test(
    'object-check',
    'One value is required',
    (value) => {
      const check = Object.keys(value).every(
        (requirement) => !value[requirement],
      );
      return !check;
    },
  ),
});

export const ApplicationQuestionsFormValidation = Yup.object().shape({
  skills: Yup.object().shape({
    Dementia: Yup.bool(),
    Incontinence: Yup.bool(),
    Hospice: Yup.bool(),
    HoyerLift: Yup.bool(),
    Parkinsons: Yup.bool(),
    GaitBelt: Yup.bool(),
    Stroke: Yup.bool(),
  }),
  okayWith: Yup.object().shape({
    cats: Yup.bool(),
    dogs: Yup.bool(),
    smokingClients: Yup.bool(),
    maleClients: Yup.bool(),
    femaleClients: Yup.bool(),
  }),
  languages: Yup.array()
    .min(1, 'Please select a language')
    .required('Please select a language')
    .nullable(),
  largestWeight: Yup.number().required('Please enter a value').nullable(true),
  educationLevel: Yup.object().test(
    'object-check',
    'One value is required',
    (value) => {
      const check = Object.keys(value).every(
        (requirement) => !value[requirement],
      );
      return !check;
    },
  ),
});
